import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { UnauthorizedRoute } from 'app/interfaces';

export const registerInvitationRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const token = route.queryParamMap.get('token');

    if (!token) {
        return true;
    }

    const router = inject(Router);
    const email = route.queryParamMap.get('email');

    return router.createUrlTree(['/' + UnauthorizedRoute.ACCOUNT_INVITATION], {
        queryParams: email ? { email } : {},
    });
};
